<template>

    <li class="nav-item">
        <a class="nav-link nav-link-firmware-image-versions" href="#" @click="showModal">
            <i class="icon-book-open mx-0"></i>
            <span class="change-indicator" v-show="firmwareImageVersionsChanged">!</span>
        </a>

        <b-modal
            id="firmware-image-versions-modal"
            title="Wersje firmware i image"
            ok-title="Zamknij"
            ok-variant="secondary"
            ok-only
            no-close-on-backdrop
            size="xl"
            @show="loadData">

            <p class="text-center my-5" v-if="loadingState">Ładowanie...</p>

            <b-tabs v-if="!loadingState" content-class="mt-3">
                <b-tab title="PROD" active>
                    <p :class="{'version-changed': firmwareImageVersionsData.prod.firmware.changed}">
                        Wersja firmware: {{ firmwareImageVersionsData.prod.firmware.version }}<br>
                        Data aktualizacji: {{ firmwareImageVersionsData.prod.firmware.updated_at }}
                    </p>
                    <p :class="{'version-changed': firmwareImageVersionsData.prod.image.changed}">
                        Wersja image: {{ firmwareImageVersionsData.prod.image.version }}<br>
                        Data aktualizacji: {{ firmwareImageVersionsData.prod.image.updated_at }}
                    </p>
                    <p class="mb-0">Changelog:</p>
                    <pre>{{ firmwareImageVersionsData.prod.changelog }}</pre>
                </b-tab>
                <b-tab title="TEST">
                    <p :class="{'version-changed': firmwareImageVersionsData.test.firmware.changed}">
                        Wersja firmware: {{ firmwareImageVersionsData.test.firmware.version }}<br>
                        Data aktualizacji: {{ firmwareImageVersionsData.test.firmware.updated_at }}
                    </p>
                    <p :class="{'version-changed': firmwareImageVersionsData.test.image.changed}">
                        Wersja image: {{ firmwareImageVersionsData.test.image.version }}<br>
                        Data aktualizacji: {{ firmwareImageVersionsData.test.image.updated_at }}
                    </p>
                    <p class="mb-0">Changelog:</p>
                    <pre>{{ firmwareImageVersionsData.test.changelog }}</pre>
                </b-tab>
                <b-tab title="DEV">
                    <p :class="{'version-changed': firmwareImageVersionsData.dev.firmware.changed}">
                        Wersja firmware: {{ firmwareImageVersionsData.dev.firmware.version }}<br>
                        Data aktualizacji: {{ firmwareImageVersionsData.dev.firmware.updated_at }}
                    </p>
                    <p :class="{'version-changed': firmwareImageVersionsData.dev.image.changed}">
                        Wersja image: {{ firmwareImageVersionsData.dev.image.version }}<br>
                        Data aktualizacji: {{ firmwareImageVersionsData.dev.image.updated_at }}
                    </p>
                    <p class="mb-0">Changelog:</p>
                    <pre>{{ firmwareImageVersionsData.dev.changelog }}</pre>
                </b-tab>
            </b-tabs>

        </b-modal>

    </li>

</template>

<script>
    export default {

        name: 'FirmwareImageVersions',

        props: [
            'firmwareImageVersionsChangedInput',
        ],

        data() {
            return {
                firmwareImageVersionsChanged: false,
                loadingState: true,
                firmwareImageVersionsData: {
                    dev: {
                        firmware: {
                            version: '---',
                            updated_at: '---',
                            changed: false,
                        },
                        image: {
                            version: '---',
                            updated_at: '---',
                            changed: false,
                        },
                        changelog: ''
                    },
                    test: {
                        firmware: {
                            version: '---',
                            updated_at: '---',
                            changed: false,
                        },
                        image: {
                            version: '---',
                            updated_at: '---',
                            changed: false,
                        },
                        changelog: '',
                    },
                    prod: {
                        firmware: {
                            version: '---',
                            updated_at: '---',
                            changed: false,
                        },
                        image: {
                            version: '---',
                            updated_at: '---',
                            changed: false,
                        },
                        changelog: '',
                    }
                },
                eventHub: window.eventHub,
            }
        },

        beforeMount() {
            this.firmwareImageVersionsChanged = this.firmwareImageVersionsChangedInput;
        },

        mounted() {

        },

        methods: {

            showModal() {
                this.loadingState = true;
                this.$bvModal.show('firmware-image-versions-modal');
            },

            modalHide() {
                this.firmwareImageVersionsData = {
                    dev: {
                        firmware: {
                            version: '---',
                                updated_at: '---',
                                changed: false,
                        },
                        image: {
                            version: '---',
                                updated_at: '---',
                                changed: false,
                        },
                        changelog: ''
                    },
                    test: {
                        firmware: {
                            version: '---',
                                updated_at: '---',
                                changed: false,
                        },
                        image: {
                            version: '---',
                                updated_at: '---',
                                changed: false,
                        },
                        changelog: '',
                    },
                    prod: {
                        firmware: {
                            version: '---',
                                updated_at: '---',
                                changed: false,
                        },
                        image: {
                            version: '---',
                                updated_at: '---',
                                changed: false,
                        },
                        changelog: '',
                    }
                };
            },

            loadData() {
                axios.get(route('get-firmware-image-versions-data'))
                    .then(response => {
                        this.firmwareImageVersionsData = {
                            dev: {
                                firmware: {
                                    version: response.data.dev.firmware.version || '---',
                                    updated_at: response.data.dev.firmware.updated_at ? this.formatDate(response.data.dev.firmware.updated_at) : '---',
                                    changed: response.data.dev.firmware_changed || false,
                                },
                                image: {
                                    version: response.data.dev.image.version || '---',
                                    updated_at: response.data.dev.image.updated_at ? this.formatDate(response.data.dev.image.updated_at) : '---',
                                    changed: response.data.dev.image_changed || false,
                                },
                                changelog: response.data.dev.changelog || ''
                            },
                            test: {
                                firmware: {
                                    version: response.data.test.firmware.version || '---',
                                    updated_at: response.data.test.firmware.updated_at ? this.formatDate(response.data.test.firmware.updated_at) : '---',
                                    changed: response.data.test.firmware_changed || false,
                                },
                                image: {
                                    version: response.data.test.image.version || '---',
                                    updated_at: response.data.test.image.updated_at ? this.formatDate(response.data.test.image.updated_at) : '---',
                                    changed: response.data.test.image_changed || false,
                                },
                                changelog: response.data.test.changelog || '',
                            },
                            prod: {
                                firmware: {
                                    version: response.data.prod.firmware.version || '---',
                                    updated_at: response.data.prod.firmware.updated_at ? this.formatDate(response.data.prod.firmware.updated_at) : '---',
                                    changed: response.data.prod.firmware_changed || false,
                                },
                                image: {
                                    version: response.data.prod.image.version || '---',
                                    updated_at: response.data.prod.image.updated_at ? this.formatDate(response.data.prod.image.updated_at) : '---',
                                    changed: response.data.prod.image_changed || false,
                                },
                                changelog: response.data.prod.changelog || '',
                            }
                        };
                        this.loadingState = false;
                        this.firmwareImageVersionsChanged = false;
                    })
            },

            formatDate(date) {
                return (new Date(date)).toLocaleString()
            }

        }

    }
</script>

<style scoped>

    .navbar .navbar-menu-wrapper .navbar-nav .nav-item .nav-link-firmware-image-versions {
        position: relative;
        width: 30px;
        height: 30px;
        border: 1px solid hsla(0,0%,100%,.2);
        border-radius: 100%;
        padding: 0;
        text-align: center;
    }

    .navbar .navbar-menu-wrapper .navbar-nav .nav-item .nav-link-firmware-image-versions i {
        font-size: .9375rem;
        margin-right: 0;
        vertical-align: middle;
        top: -1px;
        position: relative;
    }

    .navbar .navbar-menu-wrapper .navbar-nav .nav-item .nav-link-firmware-image-versions .change-indicator {
        position: absolute;
        width: 18px;
        height: 18px;
        border-radius: 100%;
        background: #d2170f !important;
        top: 16px;
        left: 18px;
        font-size: 12px;
        line-height: 1.55;
        font-weight: 700;
    }

    .version-changed {
        color: #fb3900!important;
        background: yellow;
    }

</style>
